import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Card from "react-bootstrap/Card";
import { ButtonGroup, ToggleButton } from "react-bootstrap";

import Overlay from "../../../../SharedComponents/Overlay";
import CompanyList from "./CompanyList";
import { UpdateCompanyState, UpdateName } from "../Store";
import ScrollableCard from "../../../../SharedComponents/ScrollableCard";
import { createCompany, getAllCompanies, updateCompany } from "../Store/Thunk";

export default function Company() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.company.isLoading);
  const name = useSelector((state) => state.company.name);
  const companyId = useSelector((state) => state.company.id);
  const isUpdateOperation = useSelector((state) => state.company.isUpdateOperation);
  const companyList = useSelector((state) => state.company.companyList);
  const [isArchiveActive, setIsArchiveActive] = useState(false);

  const archivedCompanies = companyList.filter((c) => !!c.isArchive);
  const nonArchivedCompanies = companyList.filter((c) => !c.isArchive);

  useEffect(() => {
    dispatch(getAllCompanies());
  }, [dispatch]);

  const submitForm = (event) => {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);

    if (isUpdateOperation)
      dispatch(
        updateCompany({
          name: formData.get("name"),
          id: companyId,
        })
      );
    else
      dispatch(
        createCompany({
          name: formData.get("name"),
        })
      );

    ClearInputs();

    event.currentTarget.reset();
  };

  const ClearInputs = () => {
    dispatch(
      UpdateCompanyState({
        name: "",
        id: "",
      })
    );
  };

  return (
    <div>
      {isLoading && <Overlay />}
      <Card body className="mb-3 default-card admin-form">
        <Form onSubmit={submitForm}>
          <Row>
            <Col xs={12} md={10}>
              <h6>{isUpdateOperation ? companyId : t("companyName")}</h6>
              <InputGroup className="mb-3">
                <Form.Control
                  required
                  name="name"
                  placeholder={t("enterCompanyName")}
                  value={name}
                  onChange={(e) => dispatch(UpdateName(e.target.value))}
                />
              </InputGroup>
            </Col>
            <Col xs={12} md={2} style={{ marginBottom: "0px !important" }}>
              <Row style={{ height: !isUpdateOperation && "100%", margin: 0 }}>
                <Button
                  className="mb-1"
                  type="submit"
                  style={{ width: "100%", height: "100%" }}
                  variant="primary"
                  disabled={!name}
                >
                  {isUpdateOperation ? t("update") : t("create")}
                </Button>
              </Row>
              {isUpdateOperation && (
                <Row style={{ margin: 0 }}>
                  <Button style={{ width: "100%", height: "100%" }} variant="secondary" onClick={ClearInputs}>
                    {t("decline")}
                  </Button>
                </Row>
              )}
            </Col>
          </Row>
        </Form>
      </Card>
      <Row className={"justify-content-between"}>
        <Col xs={"auto"}>
          <h5>
            <span>{isArchiveActive ? t("Archived") : t("NonArchived")}</span>
            <span> {t("currentCompanies")}</span>
          </h5>
        </Col>
        <Col xs={"auto"}>
          <Row className={"mx-0"}>
            <ButtonGroup className="mb-2" size="sm">
              <ToggleButton
                id={"company-nonarchived-button"}
                type="radio"
                className={`button align-content-center text-nowrap ${!isArchiveActive ? "success primary" : "secondary bg-white"}`}
                style={{ fontSize: "0.875rem", padding: "0.25rem 0.75rem" }}
                value={"nonarchived"}
                checked={!isArchiveActive}
                onClick={() => setIsArchiveActive(false)}
              >
                {t("NonArchived") + ` (${nonArchivedCompanies?.length})`}
              </ToggleButton>
              <ToggleButton
                id={"company-archived-button"}
                type="radio"
                className={`button align-content-center text-nowrap ${isArchiveActive ? "success primary" : "secondary bg-white"}`}
                style={{ fontSize: "0.875rem", padding: "0.25rem 0.75rem" }}
                value={"archived"}
                checked={isArchiveActive}
                onClick={() => setIsArchiveActive(true)}
              >
                {t("Archived") + ` (${archivedCompanies?.length})`}
              </ToggleButton>
            </ButtonGroup>
          </Row>
        </Col>
      </Row>
      <ScrollableCard>
        <CompanyList isArchiveActive={isArchiveActive} />
      </ScrollableCard>
    </div>
  );
}
